import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { serverUrl } from '../../constants'

export const customerApi = createApi({
  reducerPath: 'customerApi',
  baseQuery: fetchBaseQuery({
    baseUrl: serverUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.value
      // console.log('token state', token)
      headers.set('authorization', `Bearer ${token}`)
      headers.set('Content-Type', `application/json`)
      if (token) {
        // window.localStorage.setItem('token', token)
      }
      return headers
    }
  }),
  tagTypes: ['Customers'],
  endpoints: (builder) => ({
    fetchCustomer: builder.query({
      query: (mId) => ({
        url: `customers?mId=${mId}`,
      }),
      providesTags: ['Customers'],
    }),
    addCustomer: builder.mutation({
      query: ({ mId, ...rest }) => ({
        url: `customers?mId=${mId}`,
        method: 'POST',
        body: rest
      }),
      invalidatesTags: ['Customers'],
    }),
    updateCustomer: builder.mutation({
      query: ({ mId, id, ...rest }) => ({
        url: `customers/${id}?mId=${mId}`,
        method: 'POST',
        body: rest
      }),
      invalidatesTags: ['Customers'],
    }),
    deleteCustomer: builder.mutation({
      query: ({ mId, id, ...rest }) => ({
        url: `customers/${id}?mId=${mId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Customers'],
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useFetchCustomerQuery, useAddCustomerMutation, useUpdateCustomerMutation, useDeleteCustomerMutation } = customerApi